module.exports = __webpack_public_path__ + "media/images/category_icons/youtube_channels-b4a788e13eb10747221fbfc4b01837b1.svg";